import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoverComponent } from '@app/client/viewer/cover/cover.component';
import { PreviewComponent } from '@app/client/viewer/preview/preview.component';
import { ViewerComponent } from '@app/client/viewer/viewer.component';
import { VIEWER_ROUTES } from '@app/client/viewer/viewer.routes';
import { SharedModule } from '@app/shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DownloadProgressComponent } from './downloader/download-progress/download-progress.component';
import { DownloaderComponent } from './downloader/downloader.component';
import { ViewerEffects } from './effects';
import { ModalTransferPasswordComponent } from './modals/modal-transfer-password/modal-transfer-password.component';
import { ModalTransferAccessTrackingComponent } from './modals/modal-transfer-access-tracking/modal-transfer-access-tracking.component';
import { DeckComponent } from './preview/deck/deck.component';
import { ModalPreviewComponent } from './modals/modal-preview/modal-preview.component';
import * as fromViewer from './reducers/viewer.reducer';
import { FileCardComponent } from './preview/file-card/file-card.component';
import { SmashHeaderModule } from '@app/shared/modules/smash-header/smash-header.module';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';
import { SmashScrollbarModule } from '@app/shared/modules/smash-scrollbar/smash-scrollbar.module';
import { SmashSnackbarComponent } from './snackbar/smash-snackbar.component';
import { SmashImageModule } from '@app/shared/modules/smash-image/smash-image.module';
import { SmashSwiperModule } from '@app/shared/modules/smash-swiper/smash-swiper.module';
import { SmashPromotionModule } from '@app/shared/modules/smash-promotion/smash-promotion.module';
import { FileExtensionComponent } from './components/file-extension/file-extension.component';
import { SmashThemeModule } from '@app/shared/modules/smash-theme/smash-theme.module';
import { SmashPlayerComponent } from '@app/shared/components/smash-player/smash-player.component';
import { SmashCircularProgressModule } from '@app/shared/modules/smash-circular-progress/smash-circular-progress.module';
import { SmashCguCookiesModule } from '@app/shared/modules/smash-cgu-cookies/smash-cgu-cookies';

@NgModule({
  declarations: [
    ViewerComponent,
    CoverComponent,
    DownloaderComponent,
    DownloadProgressComponent,
    ModalTransferPasswordComponent,
    ModalTransferAccessTrackingComponent,
    PreviewComponent,
    DeckComponent,
    ModalPreviewComponent,
    FileCardComponent,
    SmashSnackbarComponent,
    FileExtensionComponent
  ],
  imports: [
    CommonModule,
    SmashHeaderModule,
    SharedModule,
    RouterModule.forChild(VIEWER_ROUTES),
    StoreModule.forFeature(fromViewer.viewerFeatureKey, fromViewer.reducer),
    EffectsModule.forFeature([ViewerEffects]),
    SmashFormsModule,
    SmashPlayerComponent,
    SmashImageModule,
    SmashScrollbarModule,
    SmashSwiperModule,
    SmashPromotionModule,
    SmashThemeModule,
    SmashCircularProgressModule,
    SmashCguCookiesModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: []
})
export class ViewerModule { }
